// Debug utilities for Supabase connection issues
import { supabase } from './supabase';

export async function checkSupabaseConnection() {
  try {
    // First, check authentication state
    const { data: authData, error: authError } = await supabase.auth.getSession();
    
    // Then, try to query a simple table
    const { data: pingData, error: pingError } = await supabase
      .from('customers')
      .select('count')
      .limit(1);
      
    // Log the results
    console.log('=== Supabase Connection Check ===');
    console.log('Auth State:', authError ? 'Error' : 'OK');
    console.log('Session:', authData?.session ? 'Active' : 'None');
    console.log('User ID:', authData?.session?.user?.id || 'Not authenticated');
    console.log('Database Connection:', pingError ? 'Error' : 'OK');
    
    if (authError) {
      console.error('Auth Error:', authError.message);
    }
    
    if (pingError) {
      console.error('Database Error:', pingError.message, pingError.details || '');
    }
    
    // Check environment variables (without exposing them fully)
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
    
    console.log('SUPABASE_URL configured:', !!supabaseUrl);
    console.log('SUPABASE_ANON_KEY configured:', !!supabaseKey);
    
    return {
      authOk: !authError,
      dbOk: !pingError,
      authenticated: !!authData?.session,
      userId: authData?.session?.user?.id
    };
  } catch (e: any) {
    console.error('Exception during connection check:', e);
    return {
      authOk: false,
      dbOk: false,
      authenticated: false,
      userId: null,
      error: e.message || String(e)
    };
  }
}
